import { useCallback } from 'react';
import arrowLeft from '~/assets/icons/arrow_left_2.svg';
import clock from '~/assets/icons/clock.svg';
import group from '~/assets/icons/group.svg';
import heart from '~/assets/icons/heart.svg';
import quote from '~/assets/icons/quote.svg';
import takeAuction from '~/assets/icons/take_auction.svg';
import { CurrencyIcon } from '~/components/collections';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import image from '../../assets/images/auction/house.png';
import {
	setItemAuctionPageVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledBackButtonContent,
	StyledBottomInfoContainer,
	StyledFeedButtonContent,
	StyledFeedButtonsContainer,
	StyledFeedContainer,
	StyledFeedHead,
	StyledFeedList,
	StyledFeedWrapper,
	StyledImageContainer,
	StyledInfoContainer,
	StyledInfoTitle,
	StyledInfoValue,
	StyledItemPageRoot,
	StyledItemPrice,
	StyledLeftContainer,
	StyledLongAuction,
	StyledMainContainer,
	StyledMyBid,
	StyledPlayerBid,
	StyledPlayersBadge,
	StyledRightContainer,
	StyledTimerBadge,
	StyledTopContainer,
} from './AppAuctionItemPage.styled';

const PlayerBid = () => (
	<StyledPlayerBid>
		<Text>
			<span style={{ fontWeight: 700 }}>Artem Bakhia</span>{' '}
			<span style={{ opacity: 0.5 }}>#43087</span>
		</Text>
		<Text>
			<span style={{ opacity: 0.5 }}>Игрок повысил ставку до</span>{' '}
			<span style={{ fontWeight: 700 }}>65 000 000</span>
		</Text>
	</StyledPlayerBid>
);

const MyBid = () => (
	<StyledMyBid>
		<Text>
			<span style={{ fontWeight: 700 }}>Ваша ставка</span>
		</Text>
		<Text>
			<span style={{ opacity: 0.5 }}>Вы повысил ставку до</span>{' '}
			<span style={{ fontWeight: 700 }}>65 000 000</span>
		</Text>
	</StyledMyBid>
);

const LongAuction = () => (
	<StyledLongAuction>
		<ImgIcon icon={clock} width={14} height={14} color="#FF1E00" />
		<Text style={{ fontWeight: 500, opacity: 0.5 }}>
			Аукцион продлен на 15 мин.
		</Text>
	</StyledLongAuction>
);

const AppAuctionItemPage = () => {
	const dispatch = useLayoutDispatch();
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const itemType = useLayoutSelector((state) => state.ads.itemType);
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handleClose = useCallback(() => {
		dispatch(setItemAuctionPageVisible(false));
	}, []);

	return (
		<StyledItemPageRoot>
			<StyledTopContainer>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					style={{ fontSize: 14, width: 'fit-content' }}
					onClick={handleClose}
				>
					<StyledBackButtonContent>
						<img src={arrowLeft} />
						<Text>Вернуться назад</Text>
					</StyledBackButtonContent>
				</Button>
				<Text
					style={{
						fontSize: 14,
						fontWeight: 700,
						color: '#ffffff',
						textAlign: 'center',
					}}
				>
					BMW M2 G87
				</Text>
				<StyledRightContainer>
					<StyledItemPrice>
						<Text style={{ fontSize: 14, color: '#ffffff', opacity: 0.25 }}>
							Ставка
						</Text>
						<Text style={{ fontSize: 14, color: '#ffffff', fontWeight: 700 }}>
							750 000
						</Text>
						<CurrencyIcon icon={rubleIcon} size="sm" />
					</StyledItemPrice>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height40}
						square
					>
						<ImgIcon icon={heart} width={14} height={14} />
					</Button>
				</StyledRightContainer>
			</StyledTopContainer>
			<StyledMainContainer>
				<StyledLeftContainer>
					<StyledImageContainer>
						<img src={image} />
						<StyledPlayersBadge>
							<img src={group} />
							<Text>10</Text>
						</StyledPlayersBadge>
						<StyledTimerBadge>
							<Text>
								2 <span>ч.</span> 35 <span>сек.</span>
							</Text>
						</StyledTimerBadge>
					</StyledImageContainer>
					<StyledInfoContainer>
						<StyledInfoTitle>
							<img src={quote} />
							<Text>Описание</Text>
						</StyledInfoTitle>
						<Text style={{ opacity: 0.5 }}>Тип имущества</Text>
						<Text style={{ fontWeight: 700, textAlign: 'right' }}>Бизнес</Text>
						<Text style={{ opacity: 0.5 }}>Гос. стоимость</Text>
						<StyledInfoValue>
							<Text style={{ fontWeight: 700 }}>50 500 000</Text>
							<CurrencyIcon icon={rubleIcon} size="sm" />
						</StyledInfoValue>
						<Text style={{ opacity: 0.5 }}>Шаг ставки</Text>
						<StyledInfoValue>
							<Text style={{ fontWeight: 700 }}>50 000</Text>
							<img src={takeAuction} />
						</StyledInfoValue>
					</StyledInfoContainer>
					<StyledBottomInfoContainer>
						<Text>14.02.24</Text>
						<Text>5 288 просмотров</Text>
					</StyledBottomInfoContainer>
				</StyledLeftContainer>
				<StyledFeedWrapper>
					<StyledFeedContainer>
						<StyledFeedHead>
							<Text style={{ fontSize: 14, fontWeight: 500, color: '#ffffff' }}>
								Трансляция аукциона
							</Text>
							<Text style={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.5)' }}>
								Участников:{' '}
								<span style={{ fontWeight: 500, color: '#FF1E00' }}>10</span>{' '}
								чел.
							</Text>
						</StyledFeedHead>
						<ScrollContainer height={372}>
							<StyledFeedList>
								<PlayerBid />
								<MyBid />
								<LongAuction />
								<PlayerBid />
								<MyBid />
								<LongAuction />
								<PlayerBid />
								<MyBid />
								<LongAuction />
							</StyledFeedList>
						</ScrollContainer>
						<StyledFeedButtonsContainer>
							<Button
								color={ButtonColors.Buy}
								borderRadius={ButtonBorderRadius.Radius5}
								height={ButtonHeight.Height40}
							>
								<StyledFeedButtonContent>
									<Text>Поднять ставку на</Text>
									<CurrencyIcon icon={rubleIcon} size="sm" asMask />
									<Text style={{ fontWeight: 700 }}>500К</Text>
								</StyledFeedButtonContent>
							</Button>
							<Button
								color={ButtonColors.Buy}
								borderRadius={ButtonBorderRadius.Radius5}
								height={ButtonHeight.Height40}
							>
								<StyledFeedButtonContent>
									<Text>Поднять ставку на</Text>
									<CurrencyIcon icon={rubleIcon} size="sm" asMask />
									<Text style={{ fontWeight: 700 }}>1KК</Text>
								</StyledFeedButtonContent>
							</Button>
						</StyledFeedButtonsContainer>
					</StyledFeedContainer>
				</StyledFeedWrapper>
			</StyledMainContainer>
		</StyledItemPageRoot>
	);
};

export { AppAuctionItemPage };
